import { EXHIBITION } from "../lib/exhibitionData";

export default function ExhibitionInfo() {
  return (
    <section
      id="exhibition"
      data-testid="exhibition-info-section"
      className="relative pl-section-dark"
    >
      {/* Red marquee ribbon */}
      <div className="bg-[#C41E1E] text-[#F5F0E8] overflow-hidden border-y border-black">
        <div className="pl-marquee-track py-4">
          {Array.from({ length: 2 }).map((_, i) => (
            <div
              key={i}
              className="flex items-center gap-10 px-10 whitespace-nowrap"
              aria-hidden={i === 1}
            >
              {[
                "Première Ligne",
                "First Line",
                "A People's Witness",
                "Dakar · Richmond",
                "April 2 — June 19, 2027",
                "Abdou Karim Ndoye",
              ]
                .concat([
                  "Première Ligne",
                  "First Line",
                  "A People's Witness",
                  "Dakar · Richmond",
                  "April 2 — June 19, 2027",
                  "Abdou Karim Ndoye",
                ])
                .map((t, j) => (
                  <span
                    key={`${i}-${j}`}
                    className="font-serif-display italic text-2xl md:text-3xl"
                  >
                    {t}
                    <span className="mx-10 not-italic">✦</span>
                  </span>
                ))}
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="overline">The Exhibition</span>
            <h2 className="mt-4 font-serif-display text-4xl md:text-5xl leading-[1.05] tracking-tight text-[#F5F0E8]">
              Bearing witness, <br />
              <span className="italic text-[#C41E1E]">made public.</span>
            </h2>
          </div>

          <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-12">
            <div className="border-t pl-hairline pt-6">
              <span className="text-[10px] uppercase tracking-[0.3em] pl-mute">
                Dates
              </span>
              <p className="mt-3 font-serif-display text-2xl md:text-3xl text-[#F5F0E8]">
                {EXHIBITION.dateRange}
              </p>
              <p className="mt-2 text-sm pl-mute">
                Public opening — Friday, April 2, 2027, 7:00 PM ET
              </p>
            </div>

            <div className="border-t pl-hairline pt-6" id="visit">
              <span className="text-[10px] uppercase tracking-[0.3em] pl-mute">
                Location
              </span>
              <p className="mt-3 font-serif-display text-2xl md:text-3xl text-[#F5F0E8]">
                {EXHIBITION.location}
              </p>
              <p className="mt-2 text-sm pl-mute">
                {EXHIBITION.address}
                <br />
                Tuesday — Sunday · 11:00 – 18:00
                <br />
                Free admission · suggested donation
              </p>
            </div>

            <div className="md:col-span-2 border-t pl-hairline pt-6">
              <p className="text-lg md:text-xl leading-relaxed text-[#F5F0E8]/85 max-w-3xl">
                Seventy-two silver-gelatin prints, a short film, and a
                room-length wall of the artist's field notes. Gathered by{" "}
                <span className="font-serif-display italic">
                  Abdou Karim Ndoye
                </span>{" "}
                during the eleven months he spent on the streets of Dakar
                around the spring of 2024. The exhibition is free and open to
                the public.
              </p>
              <div className="mt-8 flex flex-wrap gap-3">
                <a
                  href="#"
                  data-testid="exhibition-press-kit-btn"
                  className="pl-cta pl-cta-ghost"
                >
                  Download Press Kit
                </a>
                <a
                  href="#"
                  data-testid="exhibition-donate-btn"
                  className="pl-cta pl-cta-primary"
                >
                  Support the Exhibition
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
